import { createSelector, createFeatureSelector } from '@ngrx/store';

import { IState } from '@models/index';

export const orderSelector = createFeatureSelector<IState>('order');
export const getOrdersSelector = createSelector(orderSelector, (state: IState) => state); 
export const getOrderSelector = createSelector(orderSelector, (state: IState) => state.selectedItem); 